import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { toast } from "react-toastify";

interface WebhookSecretDialogProps {
  visible: boolean;
  secret: string;
  title?: string;
  onClose: () => void;
}

export default function WebhookSecretDialog({ visible, secret, title, onClose }: WebhookSecretDialogProps) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
      toast.success("Cheia a fost copiata in clipboard.");
    } catch {
      toast.error("Copiere esuata. Selecteaza si copiaza manual.");
    }
  };

  const handleClose = () => {
    setCopied(false);
    onClose();
  };

  return (
    <Dialog
      className="w-almost-full md:w-6"
      header={title ?? "Salveaza aceasta cheie acum"}
      visible={visible}
      closable={false}
      dismissableMask={false}
      onHide={handleClose}
    >
      <Message
        className="w-full mb-3"
        severity="warn"
        text="Aceasta cheie nu mai poate fi recuperata. Daca o pierzi, va trebui sa o regenerezi printr-o noua rotatie."
      />
      <div className="flex align-items-center gap-2 mb-4">
        <InputText className="flex-grow-1" value={secret} readOnly onFocus={(e) => e.target.select()} />
        <Button label={copied ? "Copiat" : "Copiaza"} icon={copied ? "pi pi-check" : "pi pi-copy"} onClick={onCopy} />
      </div>
      <Button className="block ml-auto" label="Am salvat-o" icon="pi pi-check" onClick={handleClose} />
    </Dialog>
  );
}
